<template>
  <full-reduction-promotion-details :is-edit='false'>
  </full-reduction-promotion-details>
</template>

<script>
import FullReductionPromotionDetails from '../FullReductionPromotionDetails'
export default {
  name: 'CreateFullReductionPromotion',
  components: {
    FullReductionPromotionDetails
  }
}
</script>
